import React from "react";

const HKDSymbol = ({ height, width, fillColor }) => {
  return (
    <svg
      width={width ? width : "29"}
      height={height ? height : "62"}
      viewBox="0 0 62 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9844 3.59375H18.7344V26H14.9844V16.1406H4.53125V26H0.78125V3.59375H4.53125V12.7188H14.9844V3.59375ZM31.9569 14.25L42.1756 25.6875V26H37.7225L28.2225 15.3438V26H24.4725V3.59375H28.2225V13.2344L37.41 3.59375H41.8162V3.92188L31.9569 14.25ZM61.5387 19.6562C61.5387 21.5208 60.9085 23.0365 59.6481 24.2031C58.3669 25.3594 56.5231 26.0312 54.1169 26.2188V28.875H51.5231V26.25C49.1065 26.0312 47.2523 25.276 45.9606 23.9844C44.6481 22.6719 43.945 20.9635 43.8512 18.8594H47.6481C47.7419 19.974 48.1273 20.8698 48.8044 21.5469C49.5127 22.2552 50.419 22.6823 51.5231 22.8281V16.0469L50.945 15.9219C48.9033 15.474 47.3252 14.75 46.2106 13.75C45.1273 12.7708 44.5856 11.3802 44.5856 9.57812C44.5856 7.83854 45.2054 6.41146 46.445 5.29688C47.695 4.17188 49.3877 3.53125 51.5231 3.375V0.71875H54.1169V3.375C56.2315 3.59375 57.9294 4.32812 59.2106 5.57812C60.4815 6.81771 61.1325 8.375 61.1637 10.25H57.3512C57.2575 8.33333 56.1794 7.19271 54.1169 6.82812V12.875L54.7575 13.0156C59.2783 13.9427 61.5387 16.1562 61.5387 19.6562ZM48.4606 9.57812C48.4606 10.9427 49.4815 11.8646 51.5231 12.3438V6.76562C49.4815 7.01562 48.4606 7.95312 48.4606 9.57812ZM54.1169 22.8594C56.4919 22.5781 57.6794 21.5365 57.6794 19.7344C57.6794 18.8906 57.3981 18.2188 56.8356 17.7188C56.2627 17.2396 55.3877 16.875 54.2106 16.625L54.1169 16.5938V22.8594Z"
        className={fillColor ? fillColor : "fill-text-primary"}
      />
    </svg>
  );
};

export default HKDSymbol;
